var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-divider"},[_c('div',{staticClass:"x-divider__line"}),(_vm.label)?_c('div',{staticClass:"x-divider__label t3 -t_regular",domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_c('div',{staticClass:"x-divider__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }